var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他设置")
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isIdentification
    },
    on: {
      change: _vm.changeIdentificationFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("证件识别")) + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };